module.exports = __webpack_public_path__ + "media/images/Branding/HW Word-937c6e05c869948d9715b2b21aa23ad5.png";